import type { Period } from './schemas';

/** Days turn at 00:00 in Brasília (UTC−3 all year; Brazil has had no daylight saving time since 2019). */
export const BRT_OFFSET_MS = 3 * 3_600_000;
const DAY_MS = 86_400_000;

/** 00:00 Brasília of the day an instant falls in. */
export function startOfBrasiliaDay(now: Date): Date {
  return new Date(Math.floor((now.getTime() - BRT_OFFSET_MS) / DAY_MS) * DAY_MS + BRT_OFFSET_MS);
}

/** 00:00 Brasília of a 'YYYY-MM-DD' date. */
export function brasiliaDayStart(day: string): Date {
  return new Date(Date.parse(`${day}T00:00:00.000Z`) + BRT_OFFSET_MS);
}

/** 'YYYY-MM-DD' of the Brasília day an instant falls in. */
export function brasiliaDate(at: Date): string {
  return new Date(at.getTime() - BRT_OFFSET_MS).toISOString().slice(0, 10);
}

/** Resolve a period filter into a [from, to) range of Brasília days. `from` null = unbounded. */
export function resolvePeriod(period: Period, now: Date, custom?: { from?: string; to?: string }): { from: Date | null; to: Date } {
  const startOfDay = startOfBrasiliaDay(now);
  const end = new Date(now.getTime() + 1000);
  switch (period) {
    case 'today':
      return { from: startOfDay, to: end };
    case 'yesterday':
      return { from: new Date(startOfDay.getTime() - DAY_MS), to: startOfDay };
    case '7d':
      return { from: new Date(startOfDay.getTime() - 6 * DAY_MS), to: end };
    case '30d':
      return { from: new Date(startOfDay.getTime() - 29 * DAY_MS), to: end };
    case 'all':
      return { from: null, to: end };
    case 'custom': {
      const from = custom?.from ? brasiliaDayStart(custom.from) : startOfDay;
      const to = custom?.to ? new Date(brasiliaDayStart(custom.to).getTime() + DAY_MS) : end;
      return { from, to };
    }
  }
}
